module.exports = __webpack_public_path__ + "img/project_full_delete.0ec9c093.png";